<template>
  <div id="mainSearchPanel" class="p-2">
    <div class="row">
      <div class="col-12 underline d-flex align-items-center justify-content-between">
        <div class="searchTitle">{{$ml.get('ENTER_DETAİLS')}}</div>
        <a href="https://www.minimumcrm.com/raporlar-satis-analizi#gelismis-tab" target="_blank" class="btn btn-primary text-white px-3 font-weight-bold mb-2 btnHelp"><span class="fas fa-exclamation-circle pr-2"></span>{{$ml.get('HELP')}}</a>
      </div>
    </div>

    <div class="row py-2 d-flex justify-content-between">
      <div class="col-12 col-sm-6 col-md-4 mt-2">
        <select name="" id="" @change="setObjectModel(selectedObj,'refreshSelectedSearch')" v-model="selectedObj" class="new-input">
          <option value="select" selected="selected" disabled>{{$ml.get('SELECT_CATEGORY')}}</option>
          <option value="deals">{{$ml.get('OPPORTUNITIES')}}</option>
          <option value="organizations">{{$ml.get('COMPAINES')}}</option>
          <option value="activities">{{$ml.get('ACTIVITIES')}}</option>
          <option value="contacts">{{$ml.get('PERSONS')}}</option>
          <option value="users">{{$ml.get('USERS')}}</option>
          <option value="products">{{$ml.get('PRODUCTS')}}</option>
          <!-- <option value="dealProducts">{{$ml.get('OPPORTUNITY_PRODUCTS')}}</option> -->
        </select>
      </div>
      <!-- <div class="col-4">
      </div> -->
      <div class="col-12 col-sm-6 col-md-4 mt-2">
        <select v-model="selectedSavedSearch" @change="setSavedSearchInputs()" class="new-input">
          <option :value="emptyOption">{{$ml.get('SELECT_A_SEARCH')}}</option>
          <option :value="search" v-for="(search,index) in savedSearches" v-bind:key="index">{{search.savedSearchName}}</option>
        </select>
      </div>
    </div>

    <div class="d-flex mb-5">
      <div class="col-12 p-0 pb-4">
        <div class="titleGroupBuilder">{{$ml.get('SEARCH_DESC')}}</div>
        <group-builder :item='objectModel' @sendQuery='sendPost' @saveQuery="savePost" @editQuery="editPost" :selectedSavedSearch="selectedSavedSearch" @searchDeleted="selectedSavedSearch=emptyOption" @resetSavedSearch="selectedSavedSearch=emptyOption"></group-builder>
      </div>
    </div>
    <div class="border-line-80  mb-5 pb-3">
      <div class="titleResult d-flex align-items-center justify-content-between">{{$ml.get('RESULTS')}}
         <div class="float-right" v-if="detailedSearchResult.results">

           <div class="d-flex align-items-center">
             <div class="mr-3">
                <b>{{detailedSearchResult['pageInfo']['totalCount']}}</b> {{$ml.get('RESULTS_FOUND')}}
             </div>

             <button v-if="$can('can_export_search_output')" class="d-flex align-items-center btn btn-sm exportBtn py-2" @click="exportList()">
                <img class="mr-1" src="../../assets/xls-icon.png" width="21">
                {{$ml.get('EXPORT_EXCEL')}}
             </button>

           </div>

           <!-- <p class="lead text-dark font-weight-bold">{{$can('can_export_search_output')}}</p> -->

         </div>
      </div>
      <div class="p-3" v-if="!detailedSearchResult.results">
        {{$ml.get('NO_RESULT_LISTED_YET')}}
      </div>
      <resultTable ref="rt" :detailedSearchResults="detailedSearchResult" :customFieldArray="customFieldArray" :user="user" :users="users" @firstSearchUpdate="firstSearchUpdate" @scrolled="scrollfunctionOfGrid" :firstSearch="firstSearch"></resultTable>

    </div>
      <transition name="slide-fade">
        <div class="alert alert-danger" role="alert" v-show='syntaxErrorInSearch'>
          <strong>Error :</strong> syntax error in query
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="alert alert-warning" role="alert" v-show='searchHasNoResult'>No result</div>
      </transition>
      <transition name="slide-fade"><div class="loader" v-show='searchLock'></div></transition>
      <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
  </div>
</template>

<script>
  import axios from 'axios'
  import {mapState} from 'vuex'
  import resultItem from './result-item.vue'
  import groupBuilder from './group-builder.vue'
  import resultTable from './resultTable.vue'
  import {mapActions,mapGetters} from 'vuex'
  export default {
    name: 'test',
    components: {
      resultItem,
      groupBuilder,
      resultTable
    },

    data () {
      return {
        results: [],
        searchString: '',
        objectModel: {},
        buildedSearch: '',
        searchToken: '',
        searchLock: false,
        searchComplete: false,
        searchHasNoResult: false,
        syntaxErrorInSearch: false,
        DealObj : {},
        ActivityObj : {},
        OrganizationObj : {},
        ContactObj:{},
        UserObj:{},
        ProductObj:{},
        DealProductObj:{},
        selectedObj:'select',
        lookupList:[],
        collectionList:{'activityList':'crm_activities','assignedTo':'users','assignor':'users','contacts':'contacts','cuid':'users','contactId':'contacts','deals':'deals','dealId':'deals','dealsContacts':'deals','organization':'organizations','orgId':'organizations','productList':'deal_products','productId':'products','uid':'users'},
        searchForm:{
          searchInput:{},
          lookupList:[],
          savedSearchName:'',
          searchCollection:'',
          pagingSize:30,
          pagingOffset:0
        },
        exportForm:{
          searchInput:{},
          lookupList:[],
          searchCollection:'',
          columns: []
        },
        selectedSavedSearch:{},
        emptyOption:{},
        customFieldArray:[],
        searchControl:false,
        firstSearch:true,
        domain:1,
        bottom: false,
        user:[],
        users:[],
        columnsOf:{
                'deals':[
                    { prop: "_id", name: "Id" },
                    { prop: "x", name: "x", type: "dealsStatus" },
                    { prop: "stageId", name: this.$ml.get('STEP'), type: "step",default:true },
                    { prop: "title", name: this.$ml.get('OPPORTUNITY_NAME'), type: "dealsName",default:true },
                    { prop: "value", name: this.$ml.get('VALUE'), type: "value",default:true },
                    { prop: "orgId", name: this.$ml.get('COMPANY_NAME'), type: "organization",default:true },
                    { prop: "currency", name: this.$ml.get('CURRENCY'), type: "currency" },
                    { prop: "contactId", name: this.$ml.get('CONTACT_PERSONS'), type: "contactDetail" },
                    { prop: "addDate", name: this.$ml.get('CREATION_DATE'), type: "dateObj" },
                    { prop: "cuid", name: this.$ml.get('HOLDER'), type: "user",default:true },
                    { prop: "expectedDate", name: this.$ml.get('ESTIMATED_CLOSING'), type: "dateObj",default:true },
                    { prop: "rate", name: this.$ml.get('DEGREE'), type: "rate"},
                    { prop: "source", name: this.$ml.get('SOURCE'), type: "source" },
                    { prop: "notes", name: this.$ml.get('NOTES'), type: "note" },
                    { prop: "status", name: this.$ml.get('STATUS'), type: "dealStatus",default:true },
                    { prop: "closedDate", name: this.$ml.get('CLOSING_DATE'), type: "dateObj",default:true },
                ],
                'activities':[
                    {prop:'_id',name:"Id",default:true},
                    {prop:'done',name:this.$ml.get('DONE'),type:"isDone",default:true},
                    {prop:'type',name:this.$ml.get('TYPE'),type:"activityType",default:true},
                    {prop:'subject',name:this.$ml.get('SUBJECT'),default:true},
                    {prop:'contactId',name:this.$ml.get('RELATED_PERSON'),type:'relContact'},
                    {prop:'dealId',name:this.$ml.get('RELATED_OPPORTUNITY'),type:"deal"},
                    {prop:'orgId',name:this.$ml.get('RELATED_COMPANY'),type:'organization',default:true},
                    {prop:'assignor',name:this.$ml.get('ASSIGNMENT'),type:'user',default:true},
                    {prop:'assignedTo',name:this.$ml.get('ASSIGNED'),type:'user',default:true},
                    {prop:'dueDate',name:this.$ml.get('PLANNING_HISTORY'),type:"dateObj",default:true},
                    {prop:'doneDate',name:this.$ml.get('CLOSING_DATE'),type:"dateObj",default:true},
                    {prop:'notes',name:this.$ml.get('NOTE')},
                    {prop:'duration',name:this.$ml.get('PLANNED_TIME'),type:"duration"},
                    /*{prop:'totalDeals',name:"Kapanış Tarihi"}*/
                ],
                'organizations':[
                    { prop: "_id", name: "Id" },
                    { prop: "x", name: "x", type: "orgStatus" },
                    { prop: "name", name: this.$ml.get('COMPANY_NAME'), type: "orgName",default:true },
                    { prop: "isCandidate", name: this.$ml.get('TYPE_COMPANY'), type: "candidate",default:true },
                    { prop: "contacts", name: this.$ml.get('CONTACT_PERSONS'), type: "contacts" },
                    { prop: "createdAt", name: this.$ml.get('CREATION_DATE'), type: "dateObj" },
                    { prop: "deals", name: this.$ml.get('OPPORTUNITIES'), type: "deals" },
                    { prop: "emailAddresses", name: this.$ml.get('E_MAILS'),default:true },
                    { prop: "phoneNumbers", name: this.$ml.get('PHONE_NUMBERS'), type: "phones",default:true },
                    { prop: "faxNumbers", name: this.$ml.get('FAKS_NUMBERS'), type: "phones" },
                    { prop: "webAddr", name: this.$ml.get('WEB_SITES') },
                    { prop: "addr", name: this.$ml.get('ADDRESS') },
                    { prop: "country", name: this.$ml.get('COUNTRY'), type: "country" },
                    { prop: "city", name: this.$ml.get('CITY'), type: "city",default:true },
                    { prop: "town", name: this.$ml.get('DISTRICT'), type: "town" },
                    { prop: "postalCode", name: this.$ml.get('POST_CODE') }
                ],
                'contacts': [
                    {prop:'_id',name:"Id"},
                    {prop:'n',name:this.$ml.get('NAME'),type:"contactName", default:true},
                    {prop:'sn',name:this.$ml.get('SURNAME'), default:true},
                    {prop:'tck',name:this.$ml.get('TCK')},
                    {prop:'gsm',name:"Gsm", default:true},
                    {prop:'phone',name:this.$ml.get('PHONE')},
                    {prop:'addr',name:this.$ml.get('ADDRESS')},
                    {prop:'country',name:this.$ml.get('COUNTRY'),type:'country'},
                    {prop:'city',name:this.$ml.get('CITY'),type:'city', default:true},
                    //--{prop:'town',name:"İlçe",type:'town'},
                    {prop:'fax',name:this.$ml.get('FAX')},
                    {prop:'email',name:this.$ml.get('E_MAIL'), default:true},
                    //{prop:'dob',name:"Doğum Tarihi",type:"dateObj"},
                    //{prop:'wed_ann',name:"Evlilik Yıldönümü",type:"dateObj"}
                ],
                'products': [
                    {prop:'_id',name:"Id",default:true},
                    {prop:'name',name:this.$ml.get("PRODUCT_NAME"),default:true},
                    {prop:'code',name:this.$ml.get("CODE"),default:true},
                    {prop:'prices',name:this.$ml.get("PRICE"),type:'price',default:true},
                    //{prop:'quantity',name:this.$ml.get("QUANTITY"),default:true},
                ],
                'users': [
                    {prop:'_id',name:"Id",default:true},
                    {prop: "x", name: "x", type: "userStatus" },
                    {prop:'name',name:this.$ml.get("NAME"),default:true},
                    {prop:'surName',name:this.$ml.get("SURNAME"),default:true},
                    {prop:'email',name:this.$ml.get("E_MAIL"),default:true},
                    {prop:'addDate',name:this.$ml.get("ADDITION_DATE"),type:'dateObj',default:true},
                    {prop:'updateDate',name:this.$ml.get("DATE_OF_UPDATE"),type:'dateObj',default:true},
                    {prop:'userRoleId',name:this.$ml.get("USER_ROLE"),type:'userRole',default:true},
                    {prop:'address',name:this.$ml.get("ADDRESS")},
                    {prop:'city',name:this.$ml.get("CITY"),type:'city',default:true},
                    {prop:'activation',name:this.$ml.get("IS_IT_ACTIVE"),type:'userStatus',default:true},
                ],
                //Daha sonra bakılacak !
                'dealProducts': [
                    {prop:'_id',name:"Id",default:true},
                    {prop:'productId',name:this.$ml.get("PRODUCT"),default:true},
                    {prop:'dealId',name:this.$ml.get("OPORTUNITY"),type:'deal',default:true},
                    {prop:'itemPrice',name:this.$ml.get("PRICE"),default:true},
                    {prop:'quantity',name:this.$ml.get("QUANTITY"),default:true},
                    {prop:'discountPercentage',name:this.$ml.get("DISCOUNT_PERCENTAGE"),default:true},
                    {prop:'x',name:this.$ml.get("NAME"),default:true},
                    {prop:'sum',name:this.$ml.get("TOTAL"),default:true},
                ]
        },

      }
    },

    methods: {
      ...mapActions(['getCustomFields','updateLoading','detailedSearch','getSavedSearches','resetDetailedSearch']),
      firstSearchUpdate(e) {
        this.firstSearch=e
      },

      // export buraya gelecek

      exportList(){
        this.exportForm.columns=[]
        let customFieldsArr = []

        for(let k = 0; k < this.customFieldArray.length; k++){
          customFieldsArr.push(this.customFieldArray[k]._id.$oid)
        }
        // console.log("sdfsdfsdgslknklasdatakan");
        // console.log(customFieldsArr);
        // console.log("********************************");
        this.exportForm.searchInput = this.buildedSearch
        this.exportForm.lookupList = this.lookupList

        for(let i = 0; i < Object.keys(this.columnsOf).length; i++){
          if(Object.keys(this.columnsOf)[i] == this.exportForm.searchCollection){
            if(this.selectedObj==="users"){
                customFieldsArr = []
            }
            for(let j = 0; j < this.columnsOf[Object.keys(this.columnsOf)[i]].length; j++){
              this.exportForm.columns.push(this.columnsOf[Object.keys(this.columnsOf)[i]][j].prop)
            
            }
          }
        }
        // this.exportForm.columnsOf[ this.$refs.rt.getColumnsSelector(this.selectedObj)].forEach(columns =>{
        //   if(check(column['prop'])){
        //     this.exportForm.columns.push(columns.prop)
        //     console.log("ife girdi****//////////////")
        //   }
        //   console.log("----------------9999999")
        // })
          // console.log("searchcollection"+this.exportForm.searchCollection);
        customFieldsArr.forEach(item => {

           console.log('item => ' + (this.exportForm.columns).push(item))
        })

        // console.log('this.exportForm')
        // console.log(this.exportForm.columns)

        axios({
            method:'POST',
            url:'/exportAdvancedList',
            data: this.exportForm,
            baseURL: this.baseUrl,
            withCredentials:true
        }).then((res)=>{
                return res
        }).then((res)=>{
              if(res.data.status.code==0 && res.data.content.link){
                  window.open(res.data.content.link,'_blank')
                  this.$notify({ 
                      group: 'foo',
                      type: 'success', 
                      title: this.$ml.get('SUCCESS'),
                      text: res.data.status.desc 
                  })
              }else{
                  this.$notify({ 
                      group: 'foo',
                      type: 'error', 
                      title: this.$ml.get('ERROR'),
                      text: res.data.status.desc 
                  })
              }
          })
      
      },


      getCustomF(){
            //if(this.active===false){
              axios({
                      method:'POST',
                      url:`/getCustomFields`,
                      baseURL: this.baseUrl,
                      data:{
                          domains:this.domain
                      },
                      withCredentials:true
                  }).then((res)=>{
                      return res
                  }).then((res)=>{
                      if(res.data.status.code==0){
                          this.customFieldArray = res.data.content.customFields
                      }                    
                  })
            // }
        },
      scrollfunctionOfGrid: function(
        scrollYEmit,
        clientHeightEmit,
        scrollHeightEmit
      ) {
        this.bottom = this.bottomVisible(
          scrollYEmit,
          clientHeightEmit,
          scrollHeightEmit
        );
      },
      bottomVisible(scrollYEmit, clientHeightEmit, scrollHeightEmit) {
        const scrollY = scrollYEmit;
        const visible = clientHeightEmit;
        const pageHeight = scrollHeightEmit;
        const bottomOfPage = visible + scrollY >= pageHeight;
        return bottomOfPage || pageHeight < visible;
      },
      updateCollectionlist(){
        for(var cf in this.allCustomFields){
          if(this.allCustomFields[cf].field_type==4){
            this.collectionList[this.allCustomFields[cf]._id.$oid]='users'
          }else if(this.allCustomFields[cf].field_type==8){
            this.collectionList[this.allCustomFields[cf]._id.$oid]='organizations'
          }else if(this.allCustomFields[cf].field_type==9){
            this.collectionList[this.allCustomFields[cf]._id.$oid]='contacts'
          }
        }
      },



      myList:function(data){
        
        this.lookupList=[]
        var obj = JSON.parse(data)
        console.log(data)
        if(obj['$and']!==undefined && obj['$and'].length>0){
          for(var o in obj['$and']){
            for(var value in obj['$and'][o]){
              var parts = value.split('.')
              for(var i=1 ; i<parts.length-1 ; ++i){
                var firstItem = parts[0]
                if(i==1){
                  var itemx = firstItem
                }
                itemx = itemx+"."+parts[i]
                var lookupObject = {}
                lookupObject['field']=itemx
                lookupObject['collection']=this.collectionList[parts[i]]
                this.lookupList.push(lookupObject)
              }
            }
          }
        }
        if(obj['$or']!==undefined&&obj['$or'].length>0){
          for(var o in obj['$or']){
            for(var value in obj['$or'][o]){
              var parts = value.split('.')
              for(var i=1 ; i<parts.length-1 ; ++i){
                var firstItem = parts[0]
                if(i==1){
                  var itemx = firstItem
                }
                itemx = itemx+"."+parts[i]
                var lookupObject = {}
                lookupObject['field']=itemx
                lookupObject['collection']=this.collectionList[parts[i]]
                this.lookupList.push(lookupObject)
              }
            }
          }
        }
      },



      
      sendPost: function (queryString) {
        this.searchForm.pagingOffset=0
        this.firstSearch=true
        this.results = []
        this.searchToken = ''
        this.searchComplete = false
        this.buildedSearch = queryString
        this.myList(this.buildedSearch)
        this.continueSearch(10)
      },
      savePost: function (queryString,savedSearchName) {
        // console.log("savedSearchName")
        // console.log(savedSearchName)
        this.searchForm.pagingOffset=0
        this.searchForm.savedSearchName=savedSearchName
        this.firstSearch=true
        this.results = []
        this.searchToken = ''
        this.searchComplete = false
        this.buildedSearch = queryString
        this.myList(this.buildedSearch)
        this.saveSearch(10)
      },
      editPost: function (queryString,savedSearchName,savedSearchId) {
        // console.log("savedSearchName")
        // console.log(savedSearchName)
        // console.log("savedSearchId")
        // console.log(savedSearchId)
        this.searchForm.pagingOffset=0
        this.searchForm.savedSearchName=savedSearchName
        this.searchForm.savedSearchId=savedSearchId
        this.firstSearch=true
        this.results = []
        this.searchToken = ''
        this.searchComplete = false
        this.buildedSearch = queryString
        this.myList(this.buildedSearch)
        this.editSearch(10)
      },
      setObjectModel(obj,refreshSelectedSearch){
        console.log("setObjectModel- fired")
        // console.log(obj)
        this.exportForm.columns = []

        if(refreshSelectedSearch){
          this.selectedSavedSearch = this.emptyOption
        }
        this.$refs.rt.getColumnsSelector(this.selectedObj)
        this.searchForm.searchCollection = obj
        this.exportForm.searchCollection = obj

        if(obj=='deals'){
          this.objectModel = this.DealObj
          this.domain=[1]
        }else if(obj=='organizations'){
          this.objectModel = this.OrganizationObj
          this.domain=[2]
        }else if(obj=='activities'){
          this.objectModel = this.ActivityObj
          this.domain=[5,6,7,8]
        }else if(obj=='contacts'){
          this.domain=[3]
          this.objectModel = this.ContactObj
        }else if(obj=='users'){
          this.domain=[3]
          this.objectModel = this.UserObj
        }else if(obj=='products'){
          this.domain=[4]
          this.objectModel = this.ProductObj
        }else if(obj=='dealProducts'){
          this.objectModel = this.DealProductObj
        }else{
          this.objectModel = {}
          this.selectedObj = 'select'
        }

        //this.$refs.rt.gridDataLast=[]
        this.getCustomF()
      },
      isActive(){
          axios({
              method:'POST',
              url:'/getUsers',
              baseURL: this.baseUrl,
              data: {
                  showPassiveUsers:true
              },
              withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
              if(res.data.status){
                  if(res.data.status.code==0){
                      this.user=res.data.content.user
                      this.users=res.data.content.users
                  }else{
                  }
              }else{
                  this.$router.go(-1)
              }
          })
      },
      continueSearch: function (count) {
         
        this.syntaxErrorInSearch = false

        if (this.searchLock || count < 1) {
          return
        }

        var jsonSearch = {}

        if (this.buildedSearch.length > 0) {
          try {
            jsonSearch = JSON.parse(this.buildedSearch)
          } catch (e) {
            this.searchHasNoResult = false
            this.syntaxErrorInSearch = true
            return // error in the above string (in this case, yes)!
          }
        }

        this.searchLock = true

        this.searchForm.searchInput = this.buildedSearch
        this.searchForm.lookupList = this.lookupList

        this.$store.dispatch('detailedSearch',this.searchForm).then((response) => {
            if(response=="SUCCESS"){
              this.$refs.rt.searchControl(this.firstSearch)

               
            }
        }).catch(e => {
            console.log(e)
        })

        /*
        this.$http.post('http://127.0.0.1:3000/search2', {
          searchObject: jsonSearch,
          searchToken: this.searchToken
        }).then(response => {
          if (response.body.data[0] != null) {
            this.results.push(response.body.data[0])
            this.searchToken = response.body.token
            this.searchLock = false
            this.searchHasNoResult = false
            this.continueSearch(count - 1)
          } else {
            if (this.results.length === 0) {
              console.log('No result')
              this.searchHasNoResult = true
            } else {
              this.searchComplete = true
            }
            this.searchLock = false
          }
        }).catch(function () {
          this.searchLock = false
        })*/
        this.searchLock = false
      },
      saveSearch: function (count) {
         
        this.syntaxErrorInSearch = false

        if (this.searchLock || count < 1) {
          return
        }

        var jsonSearch = {}

        if (this.buildedSearch.length > 0) {
          try {
            jsonSearch = JSON.parse(this.buildedSearch)
          } catch (e) {
            this.searchHasNoResult = false
            this.syntaxErrorInSearch = true
            return // error in the above string (in this case, yes)!
          }
        }

        this.searchLock = true

        this.searchForm.searchInput = this.buildedSearch
        this.searchForm.lookupList = this.lookupList

        this.$store.dispatch('saveSearch',this.searchForm).then((res) => {
            this.$refs.rt.searchControl(this.firstSearch)
            if(res.data.status.code=='0'){
              this.getSavedSearches()
              this.$notify({ 
                  group: 'foo',
                  type: 'success', 
                  title: this.$ml.get('SUCCESSFUL'),
                  text: res.data.status.desc
              })
              var resSSS = res.data.content.savedSearch
              this.selectedSavedSearch = resSSS
              
            }else{
              this.$notify({ 
                  group: 'foo',
                  type: 'warning', 
                  title: this.$ml.get('WARNING'),
                  text: res.data.status.desc
              })
            }
             
        }).catch(e => {
            console.log(e)
        })
        
        this.searchLock = false
      },
      editSearch: function (count) {
         
        this.syntaxErrorInSearch = false

        if (this.searchLock || count < 1) {
          return
        }

        var jsonSearch = {}

        if (this.buildedSearch.length > 0) {
          try {
            jsonSearch = JSON.parse(this.buildedSearch)
          } catch (e) {
            this.searchHasNoResult = false
            this.syntaxErrorInSearch = true
            return // error in the above string (in this case, yes)!
          }
        }

        this.searchLock = true

        this.searchForm.searchInput = this.buildedSearch
        this.searchForm.lookupList = this.lookupList

        this.$store.dispatch('editSearch',this.searchForm).then((res) => {
            this.$refs.rt.searchControl(this.firstSearch)
            if(res.data.status.code=='0'){
              this.getSavedSearches()
              this.$notify({ 
                  group: 'foo',
                  type: 'success', 
                  title: this.$ml.get('SUCCESSFUL'),
                  text: res.data.status.desc
              })
              var resSSS = res.data.content.savedSearch
              this.selectedSavedSearch = resSSS
               
            }else{
              this.$notify({ 
                  group: 'foo',
                  type: 'warning', 
                  title: this.$ml.get('WARNING'),
                  text: res.data.status.desc
              })
            }
        }).catch(e => {
            console.log(e)
        })

        
        this.searchLock = false
      },
      setSavedSearchInputs(){
        //this.selectedSavedSearch={}
        //this.detailedSearch('empty')
        // console.log("this.selectedSavedSearch.searchData on set savedsearchınputs")
        // console.log(this.selectedSavedSearch.searchData)
        if(this.selectedSavedSearch === this.emptyOption || !this.selectedSavedSearch || $.isEmptyObject(this.selectedSavedSearch)){
          return
        }
        if(this.selectedSavedSearch.searchData==undefined){
          this.selectedSavedSearch.searchData='{}'
        }

        if(typeof(this.selectedSavedSearch.searchData)=='object'){
          var searchData = this.selectedSavedSearch.searchData
        }else{
          var searchData = JSON.parse(this.selectedSavedSearch.searchData)
        }
        
        var targetCollection = searchData.searchCollection || this.selectedSavedSearch.searchCollection
        if(!targetCollection && this.selectedObj && this.selectedObj !== 'select'){
          targetCollection = this.selectedObj
        }

        if(targetCollection && targetCollection !== 'select'){
          this.selectedObj = targetCollection
          this.setObjectModel(this.selectedObj)
          this.resetDetailedSearch()
        }else{
          this.selectedSavedSearch = this.emptyOption
          swal({
            title: this.$ml.get("WARNING"),
            text: this.$ml.get("PLEASE_SELECT_CATEGORY"),
            icon: "warning",
            dangerMode: true,
          })
        }
      },
      checkScroll: function () {
        var d = document.documentElement
        var offset = d.scrollTop + window.innerHeight
        var height = d.offsetHeight

        if (offset > height - 100 && !this.searchComplete) {
          this.continueSearch(10)
        }
      },

      updateBuildedSearch: function (builded) {
        this.buildedSearch = builded
      },

      initObjectModel: function (modelArray) {
        this.objectModel = {}
        for (var i = 0; i < modelArray.length; i++) {
          var names = modelArray[i].name.split('.')
          var currentScope = this.objectModel
          for (var k = 0; k < names.length; k++) {
            var key = names[k]
            if (!(key in currentScope)) {
              if (k < names.length - 1) {
                currentScope[key] = {}
              } else {
                currentScope[key] = ''
              }
            }
            currentScope = currentScope[key]
          }
        }
      },
      createObject: function(){
        this.$store.dispatch('getCustomFields').then((response) => {
            if(response=='SUCCESS'){
              this.updateCollectionlist()
              /******** Activity Begin ********/
              this.ActivityObj = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])

              var ActivityUserObj = new this.userObject()

              this.ActivityObj.assignedTo = ActivityUserObj
              this.ActivityObj.assignor = ActivityUserObj
              this.ActivityObj.cuid = ActivityUserObj
              /********Activity Deal Begin ********/
              var ActivityDealObj = this.addCustomFieldsToObject(new this.dealObject(),1)
                var ActivityDealContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var ActivityDealContactUser = new this.userObject()
                  ActivityDealContact.uid = ActivityDealContactUser
                  
                  var ActivityDealContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                    var ActivityDealContactOrganizationUser = new this.userObject()
                    ActivityDealContactOrganization.cuid = ActivityDealContactOrganizationUser
                  ActivityDealContact.organization = ActivityDealContactOrganization
                ActivityDealObj.contactId = ActivityDealContact

                var ActivityDealUserObj = new this.userObject()
                ActivityDealObj.cuid = ActivityDealUserObj

                var ActivityDealOrganizationObj = this.addCustomFieldsToObject(new this.organizationObject(),2)
                  var ActivityDealOrganizationContactObj = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var ActivityDealOrganizationContactUserObj = new this.userObject()
                    ActivityDealOrganizationContactObj.uid = ActivityDealOrganizationContactUserObj
                  ActivityDealOrganizationObj.contacts = ActivityDealOrganizationContactObj

                  var ActivityDealOrganizationUserObj = new this.userObject()
                  ActivityDealOrganizationObj.cuid = ActivityDealOrganizationUserObj
                ActivityDealObj.orgId = ActivityDealOrganizationObj

                var ActivityDealDealProductObj = new this.dealProductObject()
                  var ActivityDealDealProductProductObj = this.addCustomFieldsToObject(new this.productObject(),4)
                  ActivityDealDealProductObj.productId = ActivityDealDealProductProductObj
                ActivityDealObj.productList=ActivityDealDealProductObj

              this.ActivityObj.dealId = ActivityDealObj
              /********Activity Deal End ********/

              /********Activity Contact Begin ********/
              var ActivityContactObj = this.addCustomFieldsToObject(new this.contactObject(),3)
                var ActivityContactUserObj = new this.userObject()
                ActivityContactObj.uid = ActivityContactUserObj

                var ActivityContactOrganizationObj = this.addCustomFieldsToObject(new this.organizationObject(),2)
                  var ActivityContactOrganizationDealObj = this.addCustomFieldsToObject(new this.dealObject(),1)
                    var ActivityContactOrganizationDealProductObj = new this.dealProductObject()
                      var ActivityContactOrganizationDealProductProductObj = this.addCustomFieldsToObject(new this.productObject(),4)
                      ActivityContactOrganizationDealProductObj.productId = ActivityContactOrganizationDealProductProductObj
                    ActivityContactOrganizationDealObj.productList = ActivityContactOrganizationDealProductObj
                  ActivityContactOrganizationObj.deals = ActivityContactOrganizationDealObj

                  var ActivityContactOrganizationUserObj = new this.userObject()
                  ActivityContactOrganizationObj.cuid = ActivityContactOrganizationUserObj
                ActivityContactObj.organization = ActivityContactOrganizationObj

              this.ActivityObj.contactId = ActivityContactObj
              /********Activity Contact End ********/
              
              /********Activity Organization Begin ********/
              var ActivityOrganizationObj = this.addCustomFieldsToObject(new this.organizationObject(),2)

                var ActivityOrganizationContactObj = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var ActivityOrganizationContactUserObj = new this.userObject()
                  ActivityOrganizationContactObj.uid = ActivityOrganizationContactUserObj
                ActivityOrganizationObj.contacts = ActivityOrganizationContactObj
                
                var ActivityOrganizationDealObj = this.addCustomFieldsToObject(new this.dealObject(),1)
                  var ActivityOrganizationDealContactObj = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var ActivityOrganizationDealContactUserObj = new this.userObject()
                    ActivityOrganizationDealContactObj.uid = ActivityOrganizationDealContactUserObj
                  ActivityOrganizationDealObj.contactId = ActivityOrganizationDealContactObj
                  
                  var ActivityOrganizationDealUserObj = new this.userObject()
                  ActivityOrganizationDealObj.cuid = ActivityOrganizationDealUserObj
                    
                  var ActivityOrganizationDealProductObj = new this.dealProductObject()
                    var ActivityOrganizationDealProductProductObj = this.addCustomFieldsToObject(new this.productObject(),4)
                    ActivityOrganizationDealProductObj.productId = ActivityOrganizationDealProductProductObj
                  ActivityOrganizationDealObj.productList = ActivityOrganizationDealProductObj
                ActivityOrganizationObj.deals = ActivityOrganizationDealObj
       
                var ActivityOrganizationUserObj = new this.userObject()
                ActivityOrganizationObj.cuid = ActivityOrganizationUserObj

              this.ActivityObj.orgId = ActivityOrganizationObj
              /******** Activity Organization End ********/
              /******** Activity End ********/
              
              /******** Deal Begin ********/
              this.DealObj = this.addCustomFieldsToObject(new this.dealObject(),1)
              
              var DealContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                var DealContactUser = new this.userObject()
                DealContact.uid = DealContactUser

                var DealContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                  var DealContactOrganizationUser = new this.userObject()
                  DealContactOrganization.cuid = DealContactOrganizationUser
                DealContact.organization = DealContactOrganization
              this.DealObj.contactId = DealContact

              var DealUser = new this.userObject()
              this.DealObj.cuid = DealUser

              var DealOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                var DealOrganizationContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var DealOrganizationContactUser = new this.userObject()
                  DealOrganizationContact.uid = DealOrganizationContactUser
                DealOrganization.contacts = DealOrganizationContact
                
                var DealOrganizationUser = new this.userObject()
                DealOrganization.cuid = DealOrganizationUser
              this.DealObj.orgId = DealOrganization

              var DealDealProduct = new this.dealProductObject()
                var DealDealProductProduct = this.addCustomFieldsToObject(new this.productObject(),4)
                DealDealProduct.productId = DealDealProductProduct
              this.DealObj.productList = DealDealProduct

              var DealActivity = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])
                var DealActivityUserObj = new this.userObject()

                DealActivity.assignedTo = DealActivityUserObj
                DealActivity.assignor = DealActivityUserObj
                DealActivity.cuid = DealActivityUserObj

                var DealActivityContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var DealActivityContactUser = new this.userObject()
                  DealActivityContact.uid = DealActivityContactUser

                  var DealActivityContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                    var DealActivityContactOrganizationUser = new this.userObject()
                    DealActivityContactOrganization.cuid = DealActivityContactOrganizationUser
                  DealActivityContact.organization = DealActivityContactOrganization
                DealActivity.contactId = DealActivityContact

                var DealActivityOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                  var DealActivityOrganizationContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var DealActivityOrganizationContactUser = new this.userObject()
                    DealActivityOrganizationContact.uid = DealActivityOrganizationContactUser
                  DealActivityOrganization.contacts = DealActivityOrganizationContact

                  var DealActivityOrganizationUser = new this.userObject()
                  DealActivityOrganization.cuid = DealActivityOrganizationUser
                DealActivity.orgId = DealActivityOrganization

              this.DealObj.activityListDeals = DealActivity
              /******** Deal End ********/

              /******** Organization Begin ********/
              this.OrganizationObj = this.addCustomFieldsToObject(new this.organizationObject(),2)

              var OrganizationContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                var OrganizationContactUser = new this.userObject()
                OrganizationContact.uid = OrganizationContactUser
              this.OrganizationObj.contactId = OrganizationContact

              var OrganizationDeal = this.addCustomFieldsToObject(new this.dealObject(),1)
                var OrganizationDealContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var OrganizationDealContactUser = new this.userObject()
                  OrganizationDealContact.uid = OrganizationDealContactUser
                OrganizationDeal.contactId = OrganizationDealContact 

                var OrganizationDealUser = new this.userObject()
                OrganizationDeal.cuid = OrganizationDealUser

                var OrganizationDealDealProduct = new this.dealProductObject()
                  var OrganizationDealDealProductProduct = this.addCustomFieldsToObject(new this.productObject(),4)
                  OrganizationDealDealProduct.productId = OrganizationDealDealProductProduct
                OrganizationDeal.productList = OrganizationDealDealProduct

                var OrganizationDealActivity = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])
                  var OrganizationDealActivityUser = new this.userObject()
                  OrganizationDealActivity.assignedTo = OrganizationDealActivityUser
                  OrganizationDealActivity.assignor = OrganizationDealActivityUser
                  OrganizationDealActivity.cuid = OrganizationDealActivityUser

                  var OrganizationDealActivityContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var OrganizationDealActivityContactUser = new this.userObject()
                    OrganizationDealActivityContact.uid = OrganizationDealActivityContactUser
                  OrganizationDealActivity.contactId = OrganizationDealActivityContact
                OrganizationDeal.activityListDeals = OrganizationDealActivity
              this.OrganizationObj.deals = OrganizationDeal 

              /******* Organization Activity *******/
              var OrganizationActivity = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])
                var OrganizationActivityUserObj = new this.userObject()

                OrganizationActivity.assignedTo = OrganizationActivityUserObj
                OrganizationActivity.assignor = OrganizationActivityUserObj
                OrganizationActivity.cuid = OrganizationActivityUserObj

                var OrganizationActivityContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var OrganizationActivityContactUser = new this.userObject()
                  OrganizationActivityContact.uid = OrganizationActivityContactUser

                  var OrganizationActivityContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                    var OrganizationActivityContactOrganizationUser = new this.userObject()
                    OrganizationActivityContactOrganization.cuid = OrganizationActivityContactOrganizationUser
                  OrganizationActivityContact.organization = OrganizationActivityContactOrganization
                OrganizationActivity.contactId = OrganizationActivityContact

                var OrganizationActivityOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                  var OrganizationActivityOrganizationContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var OrganizationActivityOrganizationContactUser = new this.userObject()
                    OrganizationActivityOrganizationContact.uid = OrganizationActivityOrganizationContactUser
                  OrganizationActivityOrganization.contacts = OrganizationActivityOrganizationContact

                  var OrganizationActivityOrganizationUser = new this.userObject()
                OrganizationActivityOrganization.cuid = OrganizationActivityOrganizationUser
                OrganizationActivity.orgId = OrganizationActivityOrganization

              this.OrganizationObj.activityList = OrganizationActivity
              

              var OrganizationUser = new this.userObject()
              this.OrganizationObj.cuid = OrganizationUser

              /******** Organization End ********/


              /******** Contact Begin ********/
              this.ContactObj = this.addCustomFieldsToObject(new this.contactObject(),3)

              var ContactUser = new this.userObject()
              this.ContactObj.uid = ContactUser

              var ContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                var ContactOrganizationDeal = this.addCustomFieldsToObject(new this.dealObject(),1)
                  var ContactOrganizationDealUser = new this.userObject()
                  ContactOrganizationDeal.cuid = ContactOrganizationDealUser

                  var ContactOrganizationDealDealProduct = new this.dealProductObject()
                    var ContactOrganizationDealDealProductProduct = this.addCustomFieldsToObject(new this.productObject(),4)
                    ContactOrganizationDealDealProduct.productId = ContactOrganizationDealDealProductProduct
                  ContactOrganizationDeal.productList = ContactOrganizationDealDealProduct

                  var ContactOrganizationDealActivity = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])
                    var ContactOrganizationDealActivityUser = new this.userObject()
                    ContactOrganizationDealActivity.assignedTo = ContactOrganizationDealActivityUser
                    ContactOrganizationDealActivity.assignor = ContactOrganizationDealActivityUser
                    ContactOrganizationDealActivity.cuid = ContactOrganizationDealActivityUser
                  ContactOrganizationDeal.activityListDeals = ContactOrganizationDealActivity
                ContactOrganization.deals = ContactOrganizationDeal

                var ContactOrganizationUser = new this.userObject()
                ContactOrganization.cuid = ContactOrganizationUser
              this.ContactObj.organization = ContactOrganization

              /******* ContactObj Deal *******/

              var ContactDeal = this.addCustomFieldsToObject(new this.dealObject(),1)
                var ContactDealContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var ContactDealContactUser = new this.userObject()
                  ContactDealContact.uid = ContactDealContactUser
                ContactDeal.contactId = ContactDealContact 

                var ContactDealUser = new this.userObject()
                ContactDeal.cuid = ContactDealUser

                var ContactDealDealProduct = new this.dealProductObject()
                  var ContactDealDealProductProduct = this.addCustomFieldsToObject(new this.productObject(),4)
                  ContactDealDealProduct.productId = ContactDealDealProductProduct
                ContactDeal.productList = ContactDealDealProduct

                var ContactDealActivity = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])
                  var ContactDealActivityUser = new this.userObject()
                  ContactDealActivity.assignedTo = ContactDealActivityUser
                  ContactDealActivity.assignor = ContactDealActivityUser
                  ContactDealActivity.cuid = ContactDealActivityUser

                  var ContactDealActivityContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var ContactDealActivityContactUser = new this.userObject()
                    ContactDealActivityContact.uid = ContactDealActivityContactUser
                  ContactDealActivity.contactId = ContactDealActivityContact
                ContactDeal.activityListDeals = ContactDealActivity
              this.ContactObj.dealsContacts = ContactDeal

              /******* ContactObj Activity *******/
              var ContactActivity = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])
                var ContactActivityUserObj = new this.userObject()

                ContactActivity.assignedTo = ContactActivityUserObj
                ContactActivity.assignor = ContactActivityUserObj
                ContactActivity.cuid = ContactActivityUserObj

                var ContactActivityContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var ContactActivityContactUser = new this.userObject()
                  ContactActivityContact.uid = ContactActivityContactUser

                  var ContactActivityContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                    var ContactActivityContactOrganizationUser = new this.userObject()
                    ContactActivityContactOrganization.cuid = ContactActivityContactOrganizationUser
                  ContactActivityContact.organization = ContactActivityContactOrganization
                ContactActivity.contactId = ContactActivityContact

                var ContactActivityOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                  var ContactActivityOrganizationContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var ContactActivityOrganizationContactUser = new this.userObject()
                    ContactActivityOrganizationContact.uid = ContactActivityOrganizationContactUser
                  ContactActivityOrganization.contacts = ContactActivityOrganizationContact

                  var ContactActivityOrganizationUser = new this.userObject()
                ContactActivityOrganization.cuid = ContactActivityOrganizationUser
                ContactActivity.orgId = ContactActivityOrganization

              this.ContactObj.activityListContacts = ContactActivity
              /******** Contact End ********/

              /******** User Begin ********/
              this.UserObj = new this.userObject()

              /******** User End ********/

              /******** Product Begin ********/
              this.ProductObj = this.addCustomFieldsToObject(new this.productObject(),4)
              /******** Product End ********/


              /******** DealProduct Begin ********/
              this.DealProductObj = new this.dealProductObject()

              var DealProductDeal = this.addCustomFieldsToObject(new this.dealObject(),1)
                var DealProductDealContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                  var DealProductDealContactUser = new this.userObject()
                  DealProductDealContact.uid = DealProductDealContactUser

                  var DealProductDealContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                    var DealProductDealOrganizationUser = new this.userObject()
                    DealProductDealContactOrganization.cuid = DealProductDealOrganizationUser
                  DealProductDealContact.organization = DealProductDealContactOrganization
                DealProductDeal.contactId = DealProductDealContact

                var DealProductDealUser = new this.userObject()
                DealProductDeal.cuid = DealProductDealUser

                var DealProductDealOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                  var DealProductDealOrganizationContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var DealProductDealOrganizationContactUser = new this.userObject()
                    DealProductDealOrganizationContact.uid = DealProductDealOrganizationContactUser
                  DealProductDealOrganization.contacts = DealProductDealOrganizationContact

                  var DealProductDealOrganizationUser = new this.userObject()
                  DealProductDealOrganization.cuid = DealProductDealOrganizationUser
                DealProductDeal.orgId = DealProductDealOrganization

                var DealProductDealActivity = this.addCustomFieldsToObject(new this.activityObject(),[5,6,7,8])
                  var DealProductDealActivityUser = new this.userObject()
                  DealProductDealActivity.assignedTo = DealProductDealActivityUser
                  DealProductDealActivity.assignor = DealProductDealActivityUser
                  DealProductDealActivity.cuid =DealProductDealActivityUser

                  var DealProductDealActivityContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                    var DealProductDealActivityContactUser = new this.userObject()
                    DealProductDealActivityContact.uid = DealProductDealActivityContactUser

                    var DealProductDealActivityContactOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                      var DealProductDealActivityContactOrganizationUser = new this.userObject()
                      DealProductDealActivityContactOrganization.cuid = DealProductDealActivityContactOrganizationUser
                    DealProductDealActivityContact.organization = DealProductDealActivityContactOrganization
                  DealProductDealActivity.contactId = DealProductDealActivityContact

                  var DealProductDealActivityOrganization = this.addCustomFieldsToObject(new this.organizationObject(),2)
                    var DealProductDealActivityOrganizationContact = this.addCustomFieldsToObject(new this.contactObject(),3)
                      var DealProductDealActivityOrganizationContactUser = new this.userObject()
                      DealProductDealActivityOrganizationContact.uid = DealProductDealActivityOrganizationContactUser
                    DealProductDealActivityOrganization.contacts = DealProductDealActivityOrganizationContact

                    var DealProductDealActivityOrganizationUser = new this.userObject()
                    DealProductDealActivityOrganization.cuid = DealProductDealActivityOrganizationUser
                  DealProductDealActivity.orgId = DealProductDealActivityOrganization

                DealProductDeal.activityListDeals = DealProductDealActivity
              this.DealProductObj.dealId = DealProductDeal

              var DealProductProduct = this.addCustomFieldsToObject(new this.productObject(),4)
              this.DealProductObj.productId = DealProductProduct
              /******** DealProduct End ********/

              this.objectModel = {/*
                'deals' : this.DealObj,
                'organizations' : OrganizationObj,
                'activities' : this.ActivityObj,
                'contacts' : ContactObj,
                'users' : UserObj,
                'products' : ProductObj,
                'dealProducts' : DealProductObj*/
              }
            }
            
        }).catch(e => {
            console.log(e)
        })
      },
      addCustomFieldsToObject:function(object,domain){
        if(typeof(domain)=="number"){
          domain=[domain]
        }
          for (var cf in this.allCustomFields){
            if(domain.includes(this.allCustomFields[cf]['domain'])){
                if(this.allCustomFields[cf]['field_type']==8){
                  var organizationObj = new this.organizationObject()
                  object[this.allCustomFields[cf]['_id']['$oid']]=organizationObj
                }else if(this.allCustomFields[cf]['field_type']==9){
                  var contactObj = new this.contactObject()
                  object[this.allCustomFields[cf]['_id']['$oid']]=contactObj
                }else if(this.allCustomFields[cf]['field_type']==4){
                  var userObj = new this.userObject()
                  object[this.allCustomFields[cf]['_id']['$oid']]=userObj
                }else{
                  object[this.allCustomFields[cf]['_id']['$oid']]= this.allCustomFields[cf]['name']
                }
            }
          }
          return object
      },
      contactObject:function (){
        this.phone=''
        this.fax=''
        this.gsm=''
        this.email=''
        this.n=''
        this.sn=''
        this.tck=''
        this.addr=''
        this.city=''
        this.dob=''
        this.wed_ann=''
        this.country=''
        this.jobTitle=''
        //uid={}//
        this.x=''
        //organization:{},//
      },
      userObject:function(){
        this.name=''
        this.surName=''
        this.email=''   
        this.x=''
        this.addDate=''
        this.updateDate=''
        this.userRoleId=''
        this.address=''
        this.city=''
        //this.town=''
        this.activation=''
      },
      organizationObject:function(){
        this.name=''
        this.phoneNumbers=''
        this.faxNumbers=''
        this.emailAddresses=''
        this.taxNo=''
        this.taxOffice=''
        //this.sector='' out of date
        this.addr=''
        this.city=''
        this.webAddr=''
        this.isCandidate=''
        //this.contacts={}//
        //this.deals={}
        //this.cuid={}
        this.x=''
        this.createdAt=''
        this.modifiedAt=''
        this.notes=''
        this.postalCode=''
        this.country=''
        //this.town='' unnecessary
      },
      dealObject:function(){
        this.title =''
        this.value =''
        this.currency =''
        //this.contactId ={}
        //this.cuid ={}
        this.x =''
        //this.orgId ={}
        this.stageId =''
        this.status =''
        this.lostReason =''
        this.addDate =''
        this.rate =''
        this.source =''
        this.expectedDate =''
        this.notes =''
        //this.productList={}
        //this.activityList={}
        this.closedDate=''
      },
      activityObject:function(){
        this.subject=''
        this.done=''
        this.type=''
        this.dueDate=''
        //this.assignedTo={}
        //this.assignor={}
        //this.cuid={}
        this.x=''
        this.doneDate=''
        this.duration=''
        //this.dealId={}
        //this.contactId={}
        //this.orgId={}
        this.notes=''
        this.addDate=''
      },
      dealProductObject:function(){
        //dealId:{},
        //productId:{},
        this.itemPrice=''
        this.quantity=''
        this.discountPercentage=''
        this.x=''
        //this.cuid=''
        this.sum=''
      },
      productObject:function(){
        this.name=''
        this.code=''
        //this.unit=''
        this.brand=''
        this.model=''
        this.tax=''
        this.prices=''
        //this.cuid=''
        this.x=''
        this.price=''
        this.currency=''
      }
    },
    watch: {
      searchString: function () {
      },

      bottom(bottom) {
        if (bottom) {
          this.searchForm.pagingOffset += this.searchForm.pagingSize;
          this.continueSearch(10)
        }
      },
    },
    created: function () {
      this.selectedSavedSearch = this.emptyOption
      /* this.$http.get('http://localhost:3000/search').then(response => {
        // this.initObjectModel(response.body.data[0])
        this.objectModel = response.body.data[0]
      })
      window.addEventListener('scroll', this.checkScroll) */
      this.createObject()
      this.getSavedSearches()
    },
    computed:{
      ...mapState([
            'baseUrl'
        ]),
        ...mapGetters(['allCustomFields','detailedSearchResult','savedSearches'])
    },
    mounted(){
      this.isActive();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #mainSearchPanel {
    width: 100%;
    overflow:hidden;
    overflow-y:auto;
  }
  .titleSelect,.titleGroupBuilder{
    background-color: #f1f2f2;
    padding: 10px 15px;
    font-size: 15px;
    margin-bottom: 15px;
    color: #9e9fa4;
  }
  .titleResult {
    background-color: #28aae1;
    padding: 10px 15px;
    font-size: 20px;
    color: #FFF;
  }
  .titleSelect{
    
  }
  .titleGroupBuilder{
    
  }
  .searchTitle{
    font-size: 16px;
    padding: 10px;
    color: #6a6b75;;
  }
  .alert {
    margin-top: 20px;
  }

  .search-input {
    width: 100%;
    margin: 0 auto;
  }
  .form-control{
    height: 30px;
    font-size: 15px;
  }
  .card {
    margin: 0 auto; /* Added */
    float: none; /* Added */
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .3s ease;
  }

  .slide-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }

  .slide-fade-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }

  .loaderContainer {
    margin: 0 auto;
    text-align: center;
  }

  .loader {
    margin: 0 auto;
    margin-top: 20px;
    border: 10px solid #f3f3f3; /* Light grey */
    border-top: 10px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: spin 1s linear infinite;
  }

  .exportBtn{
    background: #37679F;
    color: #fff;
  }
  .underline{
    border-bottom: 1px solid rgba(0, 0, 0, .125) ;
  }
  .btnHelp{
    background-color:#3767a0;

  }

  @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
  }
@media screen and (min-width: 1366px) {
    .searchTitle{
      font-size:21px;
    }
    .titleSelect,.titleGroupBuilder{
      font-size:20px;
    }
    .form-control {
      height: 42px;
      font-size: 18px;
    }
}
</style>
